import { useEffect } from "react";
const DEFAULT_APP_VERSION_PRESERVE_KEYS = [
    "period",
    "orgNode",
    "selectedForecastDate",
    "view",
    "tabState",
    "workloadDriver",
    "path",
];
const shouldPreserveKey = (key, preserveKeys) => preserveKeys.includes(key) || key.startsWith("msal.");
const clearLocalStorageForAppVersion = (preserveKeys = DEFAULT_APP_VERSION_PRESERVE_KEYS) => {
    const preserved = new Map();
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key === null || !shouldPreserveKey(key, preserveKeys)) {
            continue;
        }
        const value = localStorage.getItem(key);
        if (value !== null) {
            preserved.set(key, value);
        }
    }
    localStorage.clear();
    for (const [key, value] of preserved) {
        localStorage.setItem(key, value);
    }
};
export const useAppVersion = ({ currentVersion, callbackFn, preserveKeys = DEFAULT_APP_VERSION_PRESERVE_KEYS, }) => {
    useEffect(() => {
        const storedVersion = localStorage.getItem("app_version");
        if (storedVersion !== currentVersion) {
            clearLocalStorageForAppVersion(preserveKeys);
            callbackFn?.();
        }
        localStorage.setItem("app_version", currentVersion);
    }, [currentVersion, callbackFn, preserveKeys]);
    return null;
};
//# sourceMappingURL=useAppVersion.js.map